import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  product : null
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/reserved/recommend/index.js